import { createContext } from "react";
import { AdFormat, WBEAdFormatOption } from "../api/contracts/site-config";

export type AdFormatState = {
  /** The format currently being shown. Never null once configuration resolves. */
  format: AdFormat | undefined;
  /** Formats this site offers. Empty means no switcher is rendered. */
  options: WBEAdFormatOption[];
  selectFormat: (module: AdFormat) => void;
};

export const AdFormatContext = createContext<AdFormatState | undefined>(undefined);
